import React from 'react';
import { cn } from '../../lib/utils';
interface StepLifestylePetsProps {
  petsAllowed: boolean;
  smokingAllowed: boolean;
  onChange: (patch: {
    petsAllowed?: boolean;
    smokingAllowed?: boolean;
  }) => void;
}
export function StepLifestylePets({
  petsAllowed,
  smokingAllowed,
  onChange
}: StepLifestylePetsProps) {
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-8" data-id="element-2548">
      <div data-id="element-2549">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2550">
          Reguli de bază
        </h2>
        <p className="text-sm text-light-3" data-id="element-2551">
          Permiți animale sau fumatul în casă? Setează acum, schimbi oricând.
        </p>
      </div>

      <div className="bg-dark-2 border border-dark-3 rounded-2xl p-6 space-y-2" data-id="element-2552">
        <SwitchRow label="Pet friendly" description="Acceptă chiriași cu animale de companie." checked={petsAllowed} onChange={v => onChange({
        petsAllowed: v
      })} data-id="element-2553" />
        <SwitchRow label="Fumat permis" description="Fumatul este permis în interior." checked={smokingAllowed} onChange={v => onChange({
        smokingAllowed: v
      })} data-id="element-2554" />
      </div>
    </div>;
}
function SwitchRow({
  label,
  description,
  checked,
  onChange
}: {
  label: string;
  description: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  return <label className="flex items-center justify-between gap-4 cursor-pointer rounded-lg -mx-2 px-2 py-3 hover:bg-dark-3/40 transition-colors" onClick={e => {
    if ((e.target as HTMLElement).closest('button[role="switch"]')) return;
    onChange(!checked);
  }} data-id="element-2555">
      <div className="flex-1 min-w-0" data-id="element-2556">
        <p className="text-sm font-medium text-light-1" data-id="element-2557">{label}</p>
        <p className="text-xs text-light-3 mt-0.5" data-id="element-2558">{description}</p>
      </div>
      <button type="button" role="switch" aria-checked={checked} onClick={e => {
      e.stopPropagation();
      onChange(!checked);
    }} className={cn('relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-1 focus-visible:ring-offset-2 focus-visible:ring-offset-dark-2', checked ? 'bg-lime-1' : 'bg-dark-4')} data-id="element-2559">
        <span aria-hidden="true" className={cn('pointer-events-none inline-block h-5 w-5 transform rounded-full bg-dark-1 shadow ring-0 transition-transform', checked ? 'translate-x-5' : 'translate-x-0')} data-id="element-2560" />
      </button>
    </label>;
}